import { useContext } from 'react'
import { ComponentsContext, StoryblokContext } from '../layouts/Root'

export const useComponent = () => useContext(ComponentsContext)
export const useData = () => useContext(StoryblokContext)
